export default __webpack_public_path__ + "static/media/HYGIENE_ET_SECURITR.f1d1b59a.jpg";